import React, { createContext, useState, useContext } from "react";

const TabelaGestaoContext = createContext();

export default function ComprasProvider({ children }) {
  const [atualizacaoGestao, setAtualizacaoGestao] = useState();

  return (
    <TabelaGestaoContext.Provider
      value={{
        atualizacaoGestao,
        setAtualizacaoGestao
      }}
    >
      {children}
    </TabelaGestaoContext.Provider>
  );
}

export function useTabelaGestao() {
  const context = useContext(TabelaGestaoContext);
  //if (!context) throw new Error("useCount must be used within a CountProvider");
  const { atualizacaoGestao, setAtualizacaoGestao } = context;
  return { atualizacaoGestao, setAtualizacaoGestao };
}